import { createQueryKeys } from "@lukemorales/query-key-factory";

import {
  cancelVisit,
  editVisitCancellation,
  getAppointments,
  getBookingProviders,
  getCancelReasons,
  syncEmailEnteredToPaubox,
} from "./api";
import { BookingProvidersParams, CancelReasonType } from "./types";

export const queries = createQueryKeys("admin", {
  listCancelReasons: (type?: CancelReasonType) => {
    return {
      queryKey: ["cancel-reasons", type],
      queryFn: () => getCancelReasons({ type }),
    };
  },
  appointments: (userId: string) => {
    return {
      queryKey: ["appointments", userId],
      queryFn: () => getAppointments(userId),
    };
  },
  bookingProviders: (params: BookingProvidersParams) => {
    return {
      queryKey: ["booking-providers", params],
      queryFn: () => getBookingProviders(params),
    };
  },
});

export const mutations = {
  cancelVisit,
  editVisitCancellation,
  syncEmailEnteredToPaubox,
};
